import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { SharedComponentsModule } from '@well/shared-components';
import { LegalEntityModel } from '@well/common-libs/legal-entity-management/domain-model';

@Component({
  selector: 'well-legal-entity-card',
  standalone: true,
  imports: [CommonModule, ButtonModule, SharedComponentsModule],
  templateUrl: './legal-entity-card.component.html',
  styleUrl: './legal-entity-card.component.scss',
})
export class LegalEntityCardComponent {
  legalEntity = input<LegalEntityModel | null>(null);
  remove = output<void>();
  enableRemove = input<boolean>(true);
}
